import syrianNewFlag from '../assets/flags/syria-new.svg';

export const countries = [
	{
		name: 'Afghanistan',
		code: '+93',
		position: '-48px 0px'
	},
	{
		name: 'Albania',
		code: '+335',
		position: '-96px 0px'
	},
	{
		name: 'Algeria',
		code: '+213',
		position: '-112px -33px'
	},
	{
		name: 'Andorra',
		code: '+376',
		position: '-16px 0px'
	},
	{
		name: 'Angola',
		code: '+244',
		position: '-128px 0px'
	},
	{
		name: 'Antigua and Barbuda',
		code: '+1268',
		position: '-64px 0px'
	},
	{
		name: 'Argentina',
		code: '+54',
		position: '112px 0px'
	},
	{
		name: 'Armenia',
		code: '+374',
		position: '-112px 0px'
	},
	{
		name: 'Aruba',
		code: '+297',
		position: '48px 0px'
	},
	{
		name: 'Australia',
		code: '+61',
		position: '64px 0px'
	},
	{
		name: 'Austria',
		code: '+43',
		position: '80px 0px'
	},
	{
		name: 'Azerbaijan',
		code: '+994',
		position: '32px 0px'
	},
	{
		name: 'Bahamas',
		code: '+1242',
		position: '64px -11px'
	},
	{
		name: 'Bahrain',
		code: '+973',
		position: '-80px -11px'
	},
	{
		name: 'Bangladesh',
		code: '+880',
		position: '-16px -11px'
	},
	{
		name: 'Barbadus',
		code: '+1246',
		position: '0px -11px'
	},
	{
		name: 'Belarus',
		code: '+375',
		position: '16px -11px'
	},
	{
		name: 'Belgium',
		code: '+32',
		position: '-32px -11px'
	},
	{
		name: 'Belize',
		code: '+501',
		position: '0px -22px'
	},
	{
		name: 'Benin',
		code: '+229',
		position: '-112px -11px'
	},
	{
		name: 'Bhutan',
		code: '+975',
		position: '48px -11px'
	},
	{
		name: 'Bolivia',
		code: '+591',
		position: '96px -11px'
	},
	{
		name: 'Bosnia and Herzegovina',
		code: '+387',
		position: '16px 0px'
	},
	{
		name: 'Botswana',
		code: '+267',
		position: '32px -11px'
	},
	{
		name: 'Brazil',
		code: '+55',
		position: '80px -11px'
	},
	{
		name: 'British Indian Ocean Territory',
		code: '+246',
		position: '32px -55px'
	},
	{
		name: 'Brunai',
		code: '+673',
		position: '112px -11px'
	},
	{
		name: 'Bulgaria',
		code: '+359',
		position: '-64px -11px'
	},
	{
		name: 'Borkina Faso',
		code: '+226',
		position: '-48px -11px'
	},
	{
		name: 'Burundi',
		code: '+257',
		position: '-96px -11px'
	},
	{
		name: 'Cambodia',
		code: '+855',
		position: '128px -66px'
	},
	{
		name: 'Cameron',
		code: '+237',
		position: '112px -22px'
	},
	{
		name: 'Canada',
		code: '+1',
		position: '-16px -22px'
	},
	{
		name: 'Cape Verde',
		code: '+238',
		position: '32px -22px'
	},
	{
		name: 'Caribbean Netherlands',
		code: '+599',
		position: '128px 66px'
	},
	{
		name: 'Central African Republic',
		code: '+236',
		position: '-48px -22px'
	},
	{
		name: 'Chad',
		code: '+235',
		position: '32px 55px'
	},
	{
		name: 'Chile',
		code: '+56',
		position: '128px -22px'
	},
	{
		name: 'China',
		code: '+86',
		position: '96px -22px'
	},
	{
		name: 'Colombia',
		code: '+57',
		position: '80px -22px'
	},
	{
		name: "Comoros",
		code: '+269',
		position: '96px -66px'
	},
	{
		name: "Congo",
		code: '+243',
		position: '-32px -22px'
	},
	{
		name: "Congo",
		code: '+242',
		position: '-64px -22px'
	},
	{
		name: "Costa Rica",
		code: '+506',
		position: '64px -22px'
	},
	{
		name: "Côte d'Ivoire",
		code: '+225',
		position: '-96px -22px'
	},
	{
		name: 'Croatia',
		code: '+385',
		position: '-112px -55px'
	},
	{
		name: 'Cuba',
		code: '+53',
		position: '48px -22px'
	},
	{
		name: 'Curaçao',
		code: '+559',
		position: '16px -22px'
	},
	{
		name: 'Cyprus',
		code: '+357',
		position: '0px -33px'
	},
	{
		name: 'Czech Republic',
		code: '+420',
		position: '-16px -33px'
	},
	{
		name: 'Denmark',
		code: '+45',
		position: '-64px -33px'
	},
	{
		name: 'Djibouti',
		code: '+253',
		position: '-48px -33px'
	},
	{
		name: 'Dominican',
		code: '+1767',
		position: '-80px -33px'
	},
	{
		name: 'Dominican Republic',
		code: '+1',
		position: '-96px -33px'
	},
	{
		name: 'Ecuador',
		code: '+593',
		position: '128px -33px'
	},
	{
		name: 'Egypt',
		code: '+20',
		position: '96px 33px'
	},
	{
		name: 'EL Salvador',
		code: '+503',
		position: '-32px 33px'
	},
	{
		name: 'Equatorial Guinea',
		code: '+240',
		position: '16px -44px'
	},
	{
		name: 'Eritrea',
		code: '+291',
		position: '80px -33px'
	},
	{
		name: 'Estonia',
		code: '+372',
		position: '112px -33px'
	},
	{
		name: 'Ethiopia',
		code: '+251',
		position: '48px -33px'
	},
	{
		name: 'Fiji',
		code: '+679',
		position: '16px -33px'
	},
	{
		name: 'Finland',
		code: '+358',
		position: '32px -33px'
	},
	{
		name: 'France',
		code: '+33',
		position: '-48px -44px'
	},
	{
		name: 'French Guiana',
		code: '+594',
		position: '-48px -44px'
	},
	{
		name: 'French Polynesia',
		code: '+689',
		position: '-16px 55px'
	},
	{
		name: 'Gabon',
		code: '+241',
		position: '-64px -44px'
	},
	{
		name: 'Gambia',
		code: '+220',
		position: '64px -44px'
	},
	{
		name: 'Georgia',
		code: '+995',
		position: '-112px -44px'
	},
	{
		name: 'Germani',
		code: '+49',
		position: '-32px -33px'
	},
	{
		name: 'Ghana',
		code: '+233',
		position: '112px -44px'
	},
	{
		name: 'Greece',
		code: '+30',
		position: '0px -55px'
	},
	{
		name: 'Grenada',
		code: '+1473',
		position: '-96px -44px'
	},
	{
		name: 'Guadeloupe',
		code: '+590',
		position: '32px -44px'
	},
	{
		name: 'Guam',
		code: '+1671',
		position: '-32px -55px'
	},
	{
		name: 'Guatemala',
		code: '+502',
		position: '-16px -55px'
	},
	{
		name: 'Guinea',
		code: '+224',
		position: '48px -44px'
	},
	{
		name: 'Guinea-Bissau',
		code: '+245',
		position: '-48px -55px'
	},
	{
		name: 'Guyana',
		code: '+592',
		position: '-64px -55px'
	},
	{
		name: 'Haiti',
		code: '+509',
		position: '128px -55px'
	},
	{
		name: 'Honduras',
		code: '+504',
		position: '-96px -55px'
	},
	{
		name: 'Hong Kong',
		code: '+852',
		position: '-80px -55px'
	},
	{
		name: 'Hungary',
		code: '+36',
		position: '112px -55px'
	},
	{
		name: 'Iceland',
		code: '+354',
		position: '-16px -66px'
	},
	{
		name: 'India',
		code: '+91',
		position: '48px -55px'
	},
	{
		name: 'Indonesia',
		code: '+62',
		position: '96px -55px'
	},
	{
		name: 'Iran',
		code: '+98',
		position: '0px -66px'
	},
	{
		name: 'Iraq',
		code: '+964',
		position: '16px -55px'
	},
	{
		name: 'Ireland',
		code: '+353',
		position: '80px -55px'
	},
	{
		name: 'Israel',
		code: '+972',
		position: '64px -55px'
	},
	{
		name: 'Italy',
		code: '+39',
		position: '-32px -66px'
	},
	{
		name: 'Jamaica',
		code: '+1876',
		position: '-48px -66px'
	},
	{
		name: 'Japan',
		code: '+81',
		position: '-80px -66px'
	},
	{
		name: 'Jordan',
		code: '+962',
		position: '-64px -66px'
	},
	{
		name: 'Kazakhstan',
		code: '+7',
		position: '0px -77px'
	},
	{
		name: 'Kenya',
		code: '+254',
		position: '-96px -66px'
	},
	{
		name: 'Kiribati',
		code: '+686',
		position: '112px -66px'
	},
	{
		name: 'Kosovo',
		code: '+383',
		position: '128px 11px'
	},
	{
		name: 'Kuwait',
		code: '+965',
		position: '32px -66px'
	},
	{
		name: 'Kyrgyzstan',
		code: '+996',
		position: '-112px -66px'
	},
	{
		name: 'Laos',
		code: '+856',
		position: '-16px -77px'
	},
	{
		name: 'Latvia',
		code: '+371',
		position: '96px -77px'
	},
	{
		name: 'Lebanon',
		code: '+961',
		position: '-32px -77px'
	},
	{
		name: 'Lesotho',
		code: '+266',
		position: '-112px -77px'
	},
	{
		name: 'Liberia',
		code: '+231',
		position: '-96px -77px'
	},
	{
		name: 'Libya',
		code: '+218',
		position: '80px -77px'
	},
	{
		name: 'Liechtenstein',
		code: '+423',
		position: '-64px -77px'
	},
	{
		name: 'Lethuania',
		code: '+370',
		position: '128px -77px'
	},
	{
		name: 'Luxembourg',
		code: '+352',
		position: '112px -77px'
	},
	{
		name: 'Macau',
		code: '+853',
		position: '-96px 77px'
	},
	{
		name: 'Macedonia',
		code: '+389',
		position: '-32px 77px'
	},
	{
		name: 'Madagascar',
		code: '+261',
		position: '0px 77px'
	},
	{
		name: 'Malawi',
		code: '+265',
		position: '32px 77px'
	},
	{
		name: 'Malaysia',
		code: '+60',
		position: '0px 66px'
	},
	{
		name: 'Maldives',
		code: '+960',
		position: '48px 77px'
	},
	{
		name: 'Mali',
		code: '+223',
		position: '-48px 77px'
	},
	{
		name: 'Malta',
		code: '+356',
		position: '80px 77px'
	},
	{
		name: 'Marshall Islands',
		code: '+692',
		position: '-16px 77px'
	},
	{
		name: 'Martinique',
		code: '+596',
		position: '128px 77px'
	},
	{
		name: 'Mauritania',
		code: '+222',
		position: '112px 77px'
	},
	{
		name: 'Mauritius',
		code: '+230',
		position: '64px 77px'
	},
	{
		name: 'Mexico',
		code: '+52',
		position: '16px 77px'
	},
	{
		name: 'Mecronesia',
		code: '+691',
		position: '-16px -44px'
	},
	{
		name: 'Moldova',
		code: '+373',
		position: '32px -77px'
	},
	{
		name: 'Monaco',
		code: '+377',
		position: '48px -77px'
	},
	{
		name: 'Mongolia',
		code: '+976',
		position: '-80px 77px'
	},
	{
		name: 'Montenegro',
		code: '+382',
		position: '-112px 11px'
	},
	{
		name: 'Morocco',
		code: '+212',
		position: '64px -77px'
	},
	{
		name: 'Mozambique',
		code: '+258',
		position: '-16px 66px'
	},
	{
		name: 'Myanmar',
		code: '+95',
		position: '-64px 77px'
	},
	{
		name: 'Namibia',
		code: '+264',
		position: '-32px 66px'
	},
	{
		name: 'Nauru',
		code: '+674',
		position: '80px 66px'
	},
	{
		name: 'Nepal',
		code: '+977',
		position: '96px 66px'
	},
	{
		name: 'Netherlands',
		code: '+31',
		position: '128px 66px'
	},
	{
		name: 'New Caledonia',
		code: '+48',
		position: '-48px 66px'
	},
	{
		name: 'New Zealand',
		code: '+64',
		position: '48px 66px'
	},
	{
		name: 'Nicaragua',
		code: '+505',
		position: '-112px 66px'
	},
	{
		name: 'Niger',
		code: '+227',
		position: '-64px 66px'
	},
	{
		name: 'Nigeria',
		code: '+234',
		position: '-96px 66px'
	},
	{
		name: 'North Korea',
		code: '+850',
		position: '64px 66px'
	},
	{
		name: 'Norway',
		code: '+47',
		position: '112px 66px'
	},
	{
		name: 'Oman',
		code: '+968',
		position: '32px 66px'
	},
	{
		name: 'Pakistan',
		code: '+92',
		position: '-64px 55px'
	},
	{
		name: 'Palau',
		code: '+680',
		position: '96px 55px'
	},
	{
		name: 'Palestine',
		code: '+970',
		position: '128px 55px'
	},
	{
		name: 'Panama',
		code: '+507',
		position: '16px 66px'
	},
	{
		name: 'Papua New Guinea',
		code: '+675',
		position: '-32px 55px'
	},
	{
		name: 'Paraguay',
		code: '+595',
		position: '80px 55px'
	},
	{
		name: 'Peru',
		code: '+51',
		position: '0px 55px'
	},
	{
		name: 'Philippines',
		code: '+63',
		position: '-48px 55px'
	},
	{
		name: 'Poland',
		code: '+48',
		position: '-80px 55px'
	},
	{
		name: 'Portugal',
		code: '+351',
		position: '112px 55px'
	},
	{
		name: 'Puerto Reco',
		code: '+1',
		position: '-112px 55px'
	},
	{
		name: 'Qatar',
		code: '+974',
		position: '64px 55px'
	},
	{
		name: 'Réunion',
		code: '+262',
		position: '48px 55px'
	},
	{
		name: 'Romania',
		code: '+40',
		position: '32px 55px'
	},
	{
		name: 'Russia',
		code: '+7',
		position: '0px 44px'
	},
	{
		name: 'Rwanda',
		code: '+250',
		position: '-16px 44px'
	},
	{
		name: 'Saint Kitts and Nevis',
		code: '+1869',
		position: '80px -66px'
	},
	{
		name: 'Saint Lucia',
		code: '+1758',
		position: '-48px -77px'
	},
	{
		name: 'Saint Vincent and the Grenadines',
		code: '+1784',
		position: '80px 22px'
	},
	{
		name: 'Samoa',
		code: '+685',
		position: '-32px 11px'
	},
	{
		name: 'San Marino',
		code: '+378',
		position: '64px 44px'
	},
	{
		name: 'São Tomé and Príncipe',
		code: '+239',
		position: '-16px 33px'
	},
	{
		name: 'Saudi Arabia',
		code: '+966',
		position: '-32px 44px'
	},
	{
		name: 'Senegal',
		code: '+221',
		position: '48px 44px'
	},
	{
		name: 'Serbia',
		code: '+381',
		position: '16px 55px'
	},
	{
		name: 'Seychelles',
		code: '+248',
		position: '-64px 44px'
	},
	{
		name: 'Sierra Leone',
		code: '+232',
		position: '80px 44px'
	},
	{
		name: 'Singapore',
		code: '+65',
		position: '-112px 44px'
	},
	{
		name: 'Slovakia',
		code: '+421',
		position: '96px 44px'
	},
	{
		name: 'Slovenia',
		code: '+386',
		position: '112px 44px'
	},
	{
		name: 'Solomon Islands',
		code: '+677',
		position: '-48px 44px'
	},
	{
		name: 'Somalia',
		code: '+252',
		position: '32px 44px'
	},
	{
		name: 'South Africa',
		code: '+27',
		position: '-64px 11px'
	},
	{
		name: 'South Korea',
		code: '+82',
		position: '48px -66px'
	},
	{
		name: 'South Sudan',
		code: '+211',
		position: '0px 33px'
	},
	{
		name: 'Spian',
		code: '+34',
		position: '64px -33px'
	},
	{
		name: 'Sri Lanka',
		code: '+94',
		position: '-80px -77px'
	},
	{
		name: 'Sudan',
		code: '+249',
		position: '-80px 44px'
	},
	{
		name: 'Suriname',
		code: '+597',
		position: '16px 44px'
	},
	{
		name: 'Swaziland',
		code: '+268',
		position: '-80px 33px'
	},
	{
		name: 'Sweden',
		code: '+46',
		position: '-96px 44px'
	},
	{
		name: 'Switzerland',
		code: '+41',
		position: '-80px -33px'
	},
	{
		name: 'Syria',
		code: '+963',
		position: '-64px 33px',
		flagImage: syrianNewFlag
	},
	{
		name: 'Taiwan',
		code: '+886',
		position: '-48px 22px'
	},
	{
		name: 'Tajikstan',
		code: '+992',
		position: '96px 33px'
	},
	{
		name: 'Tanzania',
		code: '+255',
		position: '-64px 22px'
	},
	{
		name: 'Thailand',
		code: '+66',
		position: '112px 33px'
	},
	{
		name: 'Timor-Leste',
		code: '+670',
		position: '64px 33px'
	},
	{
		name: 'Togo',
		code: '+228',
		position: '128px 33px'
	},
	{
		name: 'Tonga',
		code: '+676',
		position: '16px 33px'
	},
	{
		name: 'Trindad and Tobago',
		code: '+1868',
		position: '-16px 22px'
	},
	{
		name: 'Tunisia',
		code: '+216',
		position: '32px 33px'
	},
	{
		name: 'Turkey',
		code: '+90',
		position: '0px 22px'
	},
	{
		name: 'Turkmenistan',
		code: '+993',
		position: '48px 33px'
	},
	{
		name: 'Tuvalu',
		code: '+256',
		position: '-96px 22px'
	},
	{
		name: 'Uganda',
		code: '+256',
		position: '-96px 22px'
	},
	{
		name: 'Ukraine',
		code: '+380',
		position: '-80px 22px'
	},
	{
		name: 'United Arab Emirates',
		code: '+971',
		position: '-32px 0px'
	},
	{
		name: 'United Kingdom',
		code: '+44',
		position: '-80px -44px'
	},
	{
		name: 'United States',
		code: '+1',
		position: '-112px 22px'
	},
	{
		name: 'Uruguay',
		code: '+598',
		position: '128px 22px'
	},
	{
		name: 'Uzbekistan',
		code: '+998',
		position: '112px 22px'
	},
	{
		name: 'Vanuatu',
		code: '+678',
		position: '0px 11px'
	},
	{
		name: 'Vatican City',
		code: '+39',
		position: '96px 22px'
	},
	{
		name: 'Venezuela',
		code: '+58',
		position: '64px 22px'
	},
	{
		name: 'Vietnam',
		code: '+84',
		position: '16px 22px'
	},
	{
		name: 'Yemen',
		code: '+967',
		position: '-48px 11px'
	},
	{
		name: 'Zambia',
		code: '+260',
		position: '-80px 11px'
	},
	{
		name: 'Zimbabwe',
		code: '+263',
		position: '-96px 11px'
	}
];
